module.exports = __webpack_public_path__ + "img/banner.95f56843.jpg";